<template>
  <div class="row">
    <div class="col-md-3" v-for="card in cards" :key="card.label">
      <div class="panel panel-default">
        <div class="panel-body text-center">
          <h4 class="text-muted">
            {{ card.label }}
            <CalculationTooltip :text="card.tooltip" />
          </h4>
          <p class="h3">
            {{ card.current }}
            <span class="small" :class="card.changeClass">
              {{ card.changeText }}
            </span>
          </p>
          <p class="text-muted small">Previous: {{ card.previous }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CalculationTooltip from './CalculationTooltip.vue';

export default {
  name: 'YoYComparison',
  components: { CalculationTooltip },
  props: {
    summary: { type: Object, required: true },
    yoyComparison: { type: Object, required: true }
  },
  computed: {
    cards() {
      if (!this.summary || !this.yoyComparison) return [];
      var yoy = this.yoyComparison;
      return [
        {
          label: 'Sessions YoY',
          current: this.summary.total_sessions_completed,
          previous: yoy.total_sessions_completed,
          changeText: this.formatChange(yoy.sessions_change_percent),
          changeClass: this.changeClass(yoy.sessions_change_percent),
          tooltip: 'Compares completed sessions in the current period against the previous period. "Same Period" compares to the same dates last year. "Rolling" compares to the immediately preceding period of equal length.'
        },
        {
          label: 'Hours YoY',
          current: this.summary.total_hours_delivered,
          previous: yoy.total_hours_delivered,
          changeText: this.formatChange(yoy.hours_change_percent),
          changeClass: this.changeClass(yoy.hours_change_percent),
          tooltip: 'Same comparison logic applied to total hours delivered.'
        },
        {
          label: 'Utilization YoY',
          current: this.summary.utilization_rate + '%',
          previous: '--',
          changeText: this.formatChange(yoy.utilization_change_percent),
          changeClass: this.changeClass(yoy.utilization_change_percent),
          tooltip: 'Difference in utilization rate (percentage points) between current and previous period.'
        }
      ];
    }
  },
  methods: {
    formatChange(pct) {
      if (pct == null) return '';
      var sign = pct >= 0 ? '+' : '';
      return sign + pct + '%';
    },
    changeClass(pct) {
      if (pct == null) return '';
      return pct >= 0 ? 'text-success' : 'text-danger';
    }
  }
};
</script>
